<div class="sidenav" fxLayout="column">
  <div class="sidenav-toolbar" fxLayout="row" fxLayoutAlign="start center">
    
    <div class="sidenav-toolbar-icon">
      <mat-icon>devices</mat-icon>
    </div>

    <div [routerLink]="['/']" class="sidenav-toolbar-logo">
      <h3>Nitro Console</h3>
    </div>

    <span fxFlex><!-- fill space --></span>
    
  </div>

  <app-scrollbar class="sidenav-items" fxFlex="auto">
    <div class="padding">
      <!-- espacio en blanco-->
    </div>
    <app-sidenav-item *ngFor="let item of items$ | async" [item]="item" [level]="0"></app-sidenav-item>
    <app-sidenav-item-revolution *ngFor="let item of itemsRevolution$ | async" [item]="item" [level]="0"></app-sidenav-item-revolution>
  </app-scrollbar>
  <div class="sidenav-toolbar-footer" fxLayout="row" fxLayoutAlign="end center">
    {{getVersion()}}
  </div>
</div>
